import { Injectable } from '@angular/core';

interface CountryMapping {
  [key: string]: string;
}

@Injectable({
  providedIn: 'root',
})
export class CountryService {
  private countryMapping: CountryMapping = {
    Afghanistan: 'AF',
    Albania: 'AL',
    Algeria: 'DZ',
    Andorra: 'AD',
    Angola: 'AO',
    'Antigua e Barbuda': 'AG',
    'Arabia Saudita': 'SA',
    Argentina: 'AR',
    Armenia: 'AM',
    Australia: 'AU',
    Austria: 'AT',
    Azerbaigian: 'AZ',
    Bahamas: 'BS',
    Bahrein: 'BH',
    Bangladesh: 'BD',
    Barbados: 'BB',
    Belgio: 'BE',
    Belize: 'BZ',
    Benin: 'BJ',
    Bhutan: 'BT',
    Bielorussia: 'BY',
    Birmania: 'MM',
    Bolivia: 'BO',
    'Bosnia Erzegovina': 'BA',
    Botswana: 'BW',
    Brasile: 'BR',
    Brunei: 'BN',
    Bulgaria: 'BG',
    'Burkina Faso': 'BF',
    Burundi: 'BI',
    Cambogia: 'KH',
    Camerun: 'CM',
    Canada: 'CA',
    'Capo Verde': 'CV',
    Ciad: 'TD',
    Cile: 'CL',
    Cina: 'CN',
    Cipro: 'CY',
    'Città del Vaticano': 'VA',
    Colombia: 'CO',
    Congo: 'CG',
    'Corea del Nord': 'KP',
    'Corea del Sud': 'KR',
    "Costa d'Avorio": 'CI',
    'Costa Rica': 'CR',
    Croazia: 'HR',
    Cuba: 'CU',
    Danimarca: 'DK',
    Dominica: 'DM',
    Ecuador: 'EC',
    Egitto: 'EG',
    'El Salvador': 'SV',
    'Emirati Arabi Uniti': 'AE',
    Eritrea: 'ER',
    Estonia: 'EE',
    Etiopia: 'ET',
    Figi: 'FJ',
    Filippine: 'PH',
    Finlandia: 'FI',
    Francia: 'FR',
    Gabon: 'GA',
    Gambia: 'GM',
    Georgia: 'GE',
    Germania: 'DE',
    Ghana: 'GH',
    Giamaica: 'JM',
    Giappone: 'JP',
    Gibuti: 'DJ',
    Giordania: 'JO',
    Grecia: 'GR',
    Grenada: 'GD',
    Guatemala: 'GT',
    Guinea: 'GN',
    'Guinea Equatoriale': 'GQ',
    Guyana: 'GY',
    Haiti: 'HT',
    Honduras: 'HN',
    India: 'IN',
    Indonesia: 'ID',
    Iran: 'IR',
    Iraq: 'IQ',
    Irlanda: 'IE',
    Islanda: 'IS',
    'Isole Comore': 'KM',
    'Isole Marshall': 'MH',
    'Isole Salomone': 'SB',
    Israele: 'IL',
    Italia: 'IT',
    Kazakistan: 'KZ',
    Kenya: 'KE',
    Kirghizistan: 'KG',
    Kiribati: 'KI',
    Kosovo: 'XK',
    Kuwait: 'KW',
    Laos: 'LA',
    Lesotho: 'LS',
    Lettonia: 'LV',
    Libano: 'LB',
    Liberia: 'LR',
    Libia: 'LY',
    Liechtenstein: 'LI',
    Lituania: 'LT',
    Lussemburgo: 'LU',
    Macedonia: 'MK',
    Madagascar: 'MG',
    Malawi: 'MW',
    Maldive: 'MV',
    Malesia: 'MY',
    Mali: 'ML',
    Malta: 'MT',
    Marocco: 'MA',
    Mauritania: 'MR',
    Mauritius: 'MU',
    Messico: 'MX',
    Micronesia: 'FM',
    Moldova: 'MD',
    Monaco: 'MC',
    Mongolia: 'MN',
    Montenegro: 'ME',
    Mozambico: 'MZ',
    Namibia: 'NA',
    Nauru: 'NR',
    Nepal: 'NP',
    Nicaragua: 'NI',
    Niger: 'NE',
    Nigeria: 'NG',
    Norvegia: 'NO',
    'Nuova Zelanda': 'NZ',
    Oman: 'OM',
    'Paesi Bassi': 'NL',
    Pakistan: 'PK',
    Palau: 'PW',
    Palestina: 'PS',
    Panama: 'PA',
    'Papua Nuova Guinea': 'PG',
    Paraguay: 'PY',
    Perù: 'PE',
    Polonia: 'PL',
    Portogallo: 'PT',
    Qatar: 'QA',
    'Regno Unito': 'GB',
    'Repubblica Ceca': 'CZ',
    'Repubblica Centrafricana': 'CF',
    'Repubblica Democratica del Congo': 'CD',
    'Repubblica Dominicana': 'DO',
    Romania: 'RO',
    Ruanda: 'RW',
    Russia: 'RU',
    'Saint Kitts e Nevis': 'KN',
    'Saint Vincent e Grenadine': 'VC',
    Samoa: 'WS',
    'San Marino': 'SM',
    'Santa Lucia': 'LC',
    'São Tomé e Príncipe': 'ST',
    Senegal: 'SN',
    Serbia: 'RS',
    Seychelles: 'SC',
    'Sierra Leone': 'SL',
    Singapore: 'SG',
    Siria: 'SY',
    Slovacchia: 'SK',
    Slovenia: 'SI',
    Somalia: 'SO',
    Spagna: 'ES',
    'Sri Lanka': 'LK',
    'Stati Uniti': 'US',
    'Sud Sudan': 'SS',
    Sudafrica: 'ZA',
    Sudan: 'SD',
    Suriname: 'SR',
    Svezia: 'SE',
    Svizzera: 'CH',
    Swaziland: 'SZ',
    Tagikistan: 'TJ',
    Taiwan: 'TW',
    Tanzania: 'TZ',
    Thailandia: 'TH',
    'Timor Leste': 'TL',
    Togo: 'TG',
    Tonga: 'TO',
    'Trinidad e Tobago': 'TT',
    Tunisia: 'TN',
    Turchia: 'TR',
    Turkmenistan: 'TM',
    Tuvalu: 'TV',
    Ucraina: 'UA',
    Uganda: 'UG',
    Ungheria: 'HU',
    Uruguay: 'UY',
    Uzbekistan: 'UZ',
    Vanuatu: 'VU',
    Venezuela: 'VE',
    Vietnam: 'VN',
    Yemen: 'YE',
    Zambia: 'ZM',
    Zimbabwe: 'ZW',
  };

  getCountries(): { name: string; code: string }[] {
    const italy = { name: 'Italia', code: 'IT' };
    const otherCountries = Object.entries(this.countryMapping)
      .filter(([name]) => name !== 'Italia')
      .map(([name, code]) => ({ name, code }))
      .sort((a, b) => a.name.localeCompare(b.name));

    return [italy, ...otherCountries];
  }

  getCodeFromName(name: string): string {
    return this.countryMapping[name] || '';
  }

  getNameFromCode(code: string): string {
    const entry = Object.entries(this.countryMapping).find(
      ([_, value]) => value === code.toUpperCase()
    );
    return entry ? entry[0] : '';
  }
}
